<template>
  <table
    v-if="open"
    border="1"
    class="menber-info-detail-table"
    :style="style"
  >
    <colgroup>
      <col
        v-for="(c, index) in colNum"
        :key="c"
        :width="getWidthRatio(index)"
      >
    </colgroup>
    <tbody ref="tablebody">
      <tr
        v-for="(item,index) in filterDataList"
        :key="index"
      >
        <td
          v-for="(subItem, subIndex) in item"
          :key="subIndex"
          class="row-td"
          :colspan="subItem.colspan"
        >
          <div v-if="subItem.customSlot">
            <slot
              name="label"
              :data="subItem"
            />
          </div>
          <div
            v-else
            style="margin: 10rpx;"
          >
            {{ utils.formatNull(subItem.label,'') }} <span
              v-if="subItem.extra"
              :style="[{color: subItem.extraColor||'red'}]"
            >{{ utils.formatNull(subItem.extra,'') }}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>

import { getSliceArr } from '@utils/tableUtil';
import utils from '@utils';

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: true
    },
    colNum: {
      type: Number,
      required: false,
      default: 8
    },
    dataList: {
      type: Array,
      required: true
    },
    style: {
      type: String,
      default: ''
    },
    labelWidthRatio: {
      type: Number,
      default: 0.125
    },
    valueWidthRatio: {
      type: Number,
      default: 0.125
    }
  },
  data () {
    return {}
  },
  computed: {
    utils () {
      return utils
    },
    filterDataList () {
      let keyIndex = 0
      let sumColspan = 0
      if (this.dataList == null || this.dataList.length == 0) {
        return []
      }
      const tableRows = this.dataList.reduce((rowList, item) => {
        const nameColspan = item.nameColspan || 1
        const valueColspan = item.valueColspan || 1
        if (nameColspan + valueColspan + sumColspan > this.colNum) {
          keyIndex++
          sumColspan = 0
        }
        const key = "index" + keyIndex
        if (!rowList[key]) {
          rowList[key] = []
        }
        rowList[key].push({
          label: item.name,
          colspan: item.nameColspan,
          extra: item.nameExtra,
          extraColor: item.nameExtraColor,
          customSlot: item.nameCustomSlot
        }, {
          label: item.value,
          colspan: item.valueColspan,
          extra: item.valueExtra,
          extraColor: item.valueExtraColor,
          customSlot: item.valueCustomSlot
        })
        sumColspan += nameColspan + valueColspan
        return rowList
      }, {})
      console.log("-------" + JSON.stringify(tableRows))
      return tableRows
    }
  },
  methods: {
    sliceData (dataArr) {
      return getSliceArr(dataArr, Math.floor(this.colNum / 2))
    },
    getTableTd (item, index) {
      const tabIndex = Math.floor(index / 2)
      return index % 2 == 0 ? item[tabIndex].name : item[tabIndex].value || '-'
    },
    getTableTdExtra (item, index) {
      const tabIndex = Math.floor(index / 2)
      if (index % 2 == 1 && item[tabIndex].valueExtra) {
        return {
          extra: item[tabIndex].valueExtra,
          color: { color: item[tabIndex].valueExtraColor || 'red' }
        }
      } else if (index % 2 == 0 && item[tabIndex].nameExtra) {
        return {
          extra: item[tabIndex].nameExtra,
          color: { color: item[tabIndex].nameExtraColor || 'red' }
        }
      }
      return {
        extra: '',
        color: { color: 'red' }
      }
    },
    getWidthRatio(index) {
      if (index % 2 === 0) {
        // label的宽度比例
        return this.labelWidthRatio
      } else {
        // value的宽度比例
        return this.valueWidthRatio
      }
    }
  }
}

</script>

<style>
  .menber-info-detail-table {
    table-layout: fixed;
    word-wrap:break-word;
    word-break:break-all;
  }
  table {
    border-collapse: collapse;
    width: 90%;
    margin: 0 15px;
    margin-bottom: 10px;
    text-align: center;
    border: 1px solid #cad9ea;
  }
  table td,
  table th {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
  }
  table thead th {
    background-color: #cce8eb;
  }
  .row-td:nth-child(even) {
    background: #fff;
  }
  .row-td:nth-child(odd) {
    background: #f5fafa;
  }

</style>
